import "./App.css";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { Init } from "./pages/init/Init";
import { PageNotFound } from "./features/pages/PageNotFound";
import { School } from "./pages/school/main/School";
import { Classroom } from "./pages/classroom/main/Classroom";
import { Student } from "./pages/student/main/Student";
import { SchoolInsUpd } from "./pages/school/ins-upd/SchoolInsUpd";
import { ClassroomInsUpd } from "./pages/classroom/ins-upd/ClassroomInsUpd";
import { SchoolImage } from "./pages/school/image/SchoolImage";
import { ClassroomImage } from "./pages/classroom/image/ClassroomImage";
import { StudentImage } from "./pages/student/image/StudentImage";
import { StudentInsUpd } from "./pages/student/ins-upd/StudentInsUpd";
import { ClassroomStudentAdd } from "./pages/classroom/add-student/ClassroomStudentAdd";
import { ROUTE_SCHOOL_ID, routeSchool, routeSchoolEdit, routeSchoolImage, routeSchoolNew } from "./routes/school";
import { ROUTE_CLASSROOM_ID, routeClassroom, routeClassroomEdit, routeClassroomImage, routeClassroomNew, routeClassroomStudentAdd } from "./routes/classroom";
import { ROUTE_STUDENT_ID, routeStudent, routeStudentEdit, routeStudentImage, routeStudentNew } from "./routes/student";
import { Conversations } from "./pages/init/Conversations";
import { routeConversation } from "./routes/conversation";
import { ROUTE_DPTO_ID, routeDpto, routeDptoEdit, routeDptoImage, routeDptoNew } from "./routes/dpto";
import { DptoInsUpd } from "./pages/dpto/ins-upd/DptoInsUpd";
import { DptoImage } from "./pages/dpto/image/DptoImage";
import { Dpto } from "./pages/dpto/main/Dpto";
import { Routine } from "./pages/routine/main/Routine";
import { RoutineImage } from "./pages/routine/image/RoutineImage";
import { RoutineInsUpd } from "./pages/routine/ins-upd/RoutineInsUpd";
import { EVENT_DATE, ROUTE_ROUTINE_ID, routeRoutine, routeRoutineEdit, routeRoutineFeed, routeRoutineImage, routeRoutineNew } from "./routes/routine";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import "dayjs/locale/br";
import { RoutineFeed } from "./pages/classroom/feed/RoutineFeed";

function App() {

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <Routes>
                    <Route path="/" element={<Init />} />

                    <Route path={routeSchoolNew()} element={<SchoolInsUpd />} />
                    <Route path={routeSchoolEdit(ROUTE_SCHOOL_ID)} element={<SchoolInsUpd />} />
                    <Route path={routeSchoolImage(ROUTE_SCHOOL_ID)} element={<SchoolImage />} />
                    <Route path={routeSchool(ROUTE_SCHOOL_ID)} element={<School />} />

                    <Route path={routeDptoNew(ROUTE_SCHOOL_ID)} element={<DptoInsUpd />} />
                    <Route path={routeDptoEdit(ROUTE_SCHOOL_ID, ROUTE_DPTO_ID)} element={<DptoInsUpd />} />
                    <Route path={routeDptoImage(ROUTE_SCHOOL_ID, ROUTE_DPTO_ID)} element={<DptoImage />} />
                    <Route path={routeDpto(ROUTE_SCHOOL_ID, ROUTE_DPTO_ID)} element={<Dpto />} />

                    <Route path={routeRoutineNew(ROUTE_SCHOOL_ID)} element={<RoutineInsUpd />} />
                    <Route path={routeRoutineEdit(ROUTE_SCHOOL_ID, ROUTE_ROUTINE_ID)} element={<RoutineInsUpd />} />
                    <Route path={routeRoutineImage(ROUTE_SCHOOL_ID, ROUTE_ROUTINE_ID)} element={<RoutineImage />} />
                    <Route path={routeRoutine(ROUTE_SCHOOL_ID, ROUTE_ROUTINE_ID)} element={<Routine />} />
                    <Route path={routeRoutineFeed(ROUTE_SCHOOL_ID, ROUTE_CLASSROOM_ID, ROUTE_ROUTINE_ID, EVENT_DATE)} element={<RoutineFeed />} />

                    <Route path={routeClassroomNew(ROUTE_SCHOOL_ID)} element={<ClassroomInsUpd />} />
                    <Route path={routeClassroomEdit(ROUTE_SCHOOL_ID, ROUTE_CLASSROOM_ID)} element={<ClassroomInsUpd />} />
                    <Route path={routeClassroomImage(ROUTE_SCHOOL_ID, ROUTE_CLASSROOM_ID)} element={<ClassroomImage />} />
                    <Route path={routeClassroom(ROUTE_SCHOOL_ID, ROUTE_CLASSROOM_ID)} element={<Classroom />} />
                    <Route path={routeClassroomStudentAdd(ROUTE_SCHOOL_ID, ROUTE_CLASSROOM_ID)} element={<ClassroomStudentAdd />} />

                    <Route path={routeStudentNew(ROUTE_SCHOOL_ID, ROUTE_CLASSROOM_ID)} element={<StudentInsUpd />} />
                    <Route path={routeStudentEdit(ROUTE_SCHOOL_ID, ROUTE_STUDENT_ID)} element={<StudentInsUpd />} />
                    <Route path={routeStudentImage(ROUTE_SCHOOL_ID, ROUTE_STUDENT_ID)} element={<StudentImage />} />
                    <Route path={routeStudent(ROUTE_SCHOOL_ID, ROUTE_STUDENT_ID)} element={<Student />} />
                    <Route path={routeStudent(ROUTE_SCHOOL_ID, ROUTE_STUDENT_ID, ROUTE_CLASSROOM_ID)} element={<Student />} />

                    <Route path={routeConversation()} element={<Conversations />} />

                    <Route path="*" element={<PageNotFound />} />
                </Routes>
            </BrowserRouter>
        </LocalizationProvider>
    );
}

export default App;
